import { render, staticRenderFns } from "./bidang_musrembang.vue?vue&type=template&id=41f52d44&"
import script from "./bidang_musrembang.vue?vue&type=script&lang=js&"
export * from "./bidang_musrembang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports